import * as React from "react";
import {
  Grid,
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Checkbox,
  FormControlLabel,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const CreateDateDialog = ({ open, close, next }) => {
  const { t } = useTranslation();
  const [checked, setChecked] = React.useState(false);

  const handleCheck = () => {
    if (!checked) {
      setChecked(true);
      localStorage.setItem("createDateReminder", "false");
    } else {
      setChecked(false);
      localStorage.removeItem("createDateReminder");
    }
  };
  return (
    <Dialog open={open} onClose={() => close()}>
      <DialogTitle id="alert-dialog-title">{t("createdatedialog.title")}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t("createdatedialog.warning1")}
        </DialogContentText>
        <br />
        <DialogContentText>
          {t("createdatedialog.warning2")}
        </DialogContentText>
        <br />
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
          }}
        >
          <Checkbox size="small" checked={checked} onClick={handleCheck} />
          <Typography variant="subtitle2">{t("createdatedialog.checkbox.label")}</Typography>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => close()} autoFocus>
          {t("dialog.cancel.button")}
        </Button>
        <Button
          onClick={() => {
            close();
            next();
          }}
          autoFocus
        >
          {t("dialog.continue.button")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateDateDialog;
